import moment from "moment/src/moment";

function beforeDate(label, value) {
    const startDate = new Date(value);
    startDate.setHours(0, 0, 0, 0);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    if (startDate < todayDate) {
        return true;
    }
    return label + " should be less than today";
}

export const validationMixin = {
    data: function () {
        return {
            rules: {
                required: value => !!value || "Required.",
                email: value => value && (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'E-mail must be valid') || true,
                minLength: value => value && value.length > 5 || 'Phone no should be at least 6 characters' || true,
                mobileNumberLength: value => value && value.length === 10 || 'Mobile number should be 10 digits' || true,
                minVisaLength: value => value && value.length > 4 || 'Visa number should be at least 5 characters' || true,
                futureDate: value => moment(value).isAfter(moment.now()) || "Invalid Date.",
                passportValidityDate: value => moment(value).isAfter(moment.now()) || "Validity Date cannot be of past.",
                dobValidityDate: value => {
                    return beforeDate('Date of birth', value)
                },
                marriageDate: value => {
                    return beforeDate('Marriage date', value)
                },
                number:value => {
                    if (value !== undefined &&   /\D/.test(value)){
                        return "Value should be number only"
                    }
                    return true;
                },
                beforeTodayEng: value => moment(value).isBefore(moment.now()) || "Date cannot be of future.",
                certificationDate: value => moment(value).isBefore(moment.now()) || "Certification date cannot be of the future ",
                maximumDays: value => value && parseInt(value) < 9999 || 'Maximum days is 9999',
                international_number: value => value && value.length <= 16 || "The number shouldn't be maximum than 16 characters",
                alphaSpace : value => value && (/^[A-Za-z ]+$/.test(value)) || "Value should not be number"

            },
        }
    }
};
